import { createContext, useContext } from 'react';
import { type useCommunications } from './useCommunications';

type Communications = ReturnType<typeof useCommunications>;

export const CommunicationContext = createContext<Communications | null>(null);

export const useCommunicationContext = (): Communications => {
    const communication = useContext(CommunicationContext);

    if (!communication) {
        throw new Error('Communication requires CommunicationProvider');
    }

    return communication;
};
